
import { BRAND_NAME } from "../../config/constants";

const programs = [
    {
        "title": BRAND_NAME,
        "describe": `${BRAND_NAME} is a time banking platform that empowers children like you to drive charitable projects you are passionate about. All you need is passion and skill to do good and pay it forward.`,
        "image": `${process.env.REACT_APP_R2_URL}/socialcred.jpeg`,
        "website": "https://www.socialcreds.com/"
    },
    {
        "title": "Job Cred$",
        "describe": "Gift of Time Foundation and St Aloysius College launch Job Cred$ - an explosive internship program designed to get soon to graduate students get job ready",
        "image": `${process.env.REACT_APP_R2_URL}/jobcred.jpeg`,
        "website": "https://www.jobcreds.com/"

    },
    {
        "title": "Human Library",
        "describe": "Offer your varied expertise to the world by plugging in your profile.",
        "image": `${process.env.REACT_APP_R2_URL}/humanlib.jpeg`,
        "website": `https://www.${process.env.REACT_APP_HOST_NAME}.in/human-library`
    }

]

export default programs